import { useListFolderEntities } from "@/queries";

const useExpandedItems = (folderId?: number) => {
  const query = useListFolderEntities({
    folder_id: folderId ?? null,
    enabled: folderId !== undefined,
    include_metadata: true,
    keepPreviousData: false,
  });

  return query;
};

export default useExpandedItems;
